import apiClient from '@/services/axios'

export async function get(bookingId) {

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/caseworkers');

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get caseworkers.')
}
